import { css } from '@emotion/react';
import { blue05, novoEdBlue } from 'athena/styles/colors';
import t from 'react-translate';
import NvIcon from 'shared/components/nv-icon';
import prodPathReplace from 'shared/prod-path-rewrite';
import { quarterSpacing, standardSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  border-radius: ${quarterSpacing}px;
  background-color: ${blue05};

  .participant-experience-icon {
    color: ${novoEdBlue};
  }

  .participant-experience-image {
    img {
      max-width: 150px;
      border-radius: ${standardSpacing}px;
    }
  }
`;

const ParticipantExperience = () => {
  const translationBase = t.MENTORING_PROGRAMS.SETTINGS.TABS.GUIDANCE.PARTICIPANT_EXPERIENCE;

  return (
    <div css={styles} className='d-flex w-100 p-3 col align-items-center mb-4'>
      <NvIcon icon='ideas' size='small' className='mr-2 participant-experience-icon' />
      <div className='mr-2 black'>
        {translationBase.DESCRIPTION()}
      </div>
      <div className='participant-experience-image'>
        <img
          src={prodPathReplace('images/planning-first-meeting.gif')}
          alt={translationBase.ALT_LABEL()}
        />
      </div>
    </div>
  );
}

export default ParticipantExperience;
